import { render, staticRenderFns } from "./DeviceAssignment.vue?vue&type=template&id=de53cf60&scoped=true&"
import script from "./DeviceAssignment.vue?vue&type=script&lang=ts&"
export * from "./DeviceAssignment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de53cf60",
  null
  
)

export default component.exports